import classnames from "classnames";
import { ADMIN_PANEL_SECTION_CONFIG_FE_STATUS } from "features/AdminPanel/constants/AdminPanel.constants";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import React from "react";
import {
  SAVING_STATUS_CLASSES,
  SAVING_STATUS_ICONS,
  SAVING_STATUS_MESSAGES,
  STATUS_VISIBLE_DURATION_WITHOUT_ANIMATION,
} from "./constants/SavingStatus.constants";
import { getUpdationStatus } from "./utils/SavingStatus.utils";

export const SavingStatus = ({ className = "", customStore }) => {
  const getSectionConfig = (state) => state.sectionConfig;

  // @dev we are making use of the same component for handling saving status, since flow is same only the store differs

  const useCustomStore = customStore ?? useAdminPanelStore;

  const sectionConfig = useCustomStore(getSectionConfig);
  const status = getUpdationStatus(sectionConfig);
  const icon = SAVING_STATUS_ICONS[status];
  const label = SAVING_STATUS_MESSAGES[status];
  const [fadeOut, setFadeOut] = React.useState(false);

  // show fade out animation on successful save or error
  React.useEffect(() => {
    let timer;

    if (
      status === ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.SAVED ||
      status === ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.ERROR
    ) {
      timer = setTimeout(() => {
        setFadeOut(true);
      }, STATUS_VISIBLE_DURATION_WITHOUT_ANIMATION);
    } else {
      setFadeOut(false);
    }

    return () => clearTimeout(timer);
  }, [status]);

  if (!status) return null;

  return (
    <div
      className={classnames(
        "tw-transition-opacity tw-duration-200 tw-text-lg tw-leading-[normal] max-md:tw-text-center max-md:tw-py-[5px] max-md:tw-mt-[-12px] tw-font-bold max-md:tw-font-medium max-md:tw-text-sm max-md:tw-shadow-sm tw-z-10 max-md:tw-sticky max-md:tw-top-0",
        fadeOut ? "tw-opacity-0" : "tw-opacity-100",
        SAVING_STATUS_CLASSES[status],
        className
      )}
    >
      {icon} {label}
    </div>
  );
};
